
export const ACTION_TOOL_BOOK_STATEMENT_STOCKS_LIST = 'ACTION_TOOL_BOOK_STATEMENT_STOCKS_LIST';



// WEBPACK FOOTER //
// ./src/store/Admin/modules/inventoryManagement/types.js